/**
 * Random UUID v4 that works on every page.
 *
 * crypto.randomUUID() exists only in "secure contexts" (HTTPS or localhost). Opened over
 * plain http on the office Wi-Fi (e.g. http://192.168.x.x:5173) it is undefined, which made
 * new photos silently disappear. crypto.getRandomValues() is available everywhere.
 */
export function uuid(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = ((b[6] ?? 0) & 0x0f) | 0x40; // version 4
  b[8] = ((b[8] ?? 0) & 0x3f) | 0x80; // RFC 4122 variant
  const hex = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
